import { ErrorController as controller } from './error.controller';
import template from './error.html';

export const errorComponent = {
  name: 'errorComponent',
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    returnTo: '<',
  },
};
